import { getFromGlobalScope } from '@scripts/helpers';

const sentryDsnFrontend = getFromGlobalScope('sentryDsnFrontend', null);
if (sentryDsnFrontend !== null) {
    window.Sentry.init({
        dsn: sentryDsnFrontend,
    });
}
